import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorMasterCategoryMainList = () => {
  const categoryMainList = useCallback((body, callback) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/master-category/main-list', payload, response => {
      if (response.status_code === 200) {
        const { data } = response
        callback(data)
      }
    })
  }, [])

  return { categoryMainList }
}

export default InteractorMasterCategoryMainList
